var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backwards"},[_c('a',{staticClass:"mb-4 grey--text text-body-2 text-uppercase d-inline-block",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("arrow_back")]),_vm._v(" zurück ")],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }